import { useTranslation } from 'react-i18next';

import defaultProductImage from 'assets/images/default-product-image.png';

import { OrderItem as ItemOfOrder } from 'types/pwcOrder';

import { formatCurrencySymbol, formatNumberI18n } from 'utils/i18n';

import { Value } from '../styles';
import KEYS from './keys';
import { OrderItemImage, OrderItemName } from './styles';

const OrderItem = ({ name, imageUrl, fiatAmount, currency }: ItemOfOrder & { currency: string }) => {
  const { t, i18n } = useTranslation();
  const formattedSymbol = formatCurrencySymbol(i18n.language)(currency);
  const numberFormatter = formatNumberI18n(i18n.language);
  const formattedAmount = numberFormatter(Number(fiatAmount));

  return (
    <>
      <OrderItemImage src={imageUrl || defaultProductImage} alt={name} /> <OrderItemName>{name}</OrderItemName> {t(KEYS.DASH)}
      <Value>
        <span>{formattedAmount}</span>
        <span>{formattedSymbol}</span>
      </Value>
    </>
  );
};

export default OrderItem;
